import { render, staticRenderFns } from "./PlayerProgress.vue?vue&type=template&id=536b518b&scoped=true"
import script from "./PlayerProgress.vue?vue&type=script&lang=js"
export * from "./PlayerProgress.vue?vue&type=script&lang=js"
import style0 from "./PlayerProgress.vue?vue&type=style&index=0&id=536b518b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b518b",
  null
  
)

export default component.exports